import { isNumber } from 'cpool-utils';

export const API = {
    AVATAR_PATH: import.meta.env.VITE_REACT_APP_AVATAR_PATH
        ? import.meta.env.VITE_REACT_APP_AVATAR_PATH
        : '/img/avatars/',
    URL: import.meta.env.VITE_REACT_APP_API_URL ? import.meta.env.VITE_REACT_APP_API_URL : 'http://localhost:3000',
};

export const FPS = {
    API_HOST: import.meta.env.VITE_REACT_APP_FPS_API_HOST ?? 'https://dev.fps.kredit.de',
    API_KEY: import.meta.env.VITE_REACT_APP_FPS_API_KEY ?? '',
    API_URL: import.meta.env.VITE_REACT_APP_FPS_API_URL ?? 'http://localhost:3010',
    IBAN_TOKEN:
        import.meta.env.VITE_REACT_APP_FPS_IBAN_TOKEN ??
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzY29wZSI6ImFwaSBpYmFuIiwid3MiOiJsb2NhbGhvc3QiLCJ0aWQiOiI2MTRkZjA2ZS00MjlmLTQyZDgtOWRlYi00MGJlYzVlOGQ0YzMiLCJpYXQiOjE2ODUwMTY4NjQsImlzcyI6ImZwcy5rcmVkaXQuZGUiLCJzdWIiOiJhcGkifQ.tuARawfMZLgsIgR_2Zz_-Oye--GEbIANHRTN2B3mDUk',
    SERVICE_ID: import.meta.env.VITE_REACT_APP_FPS_SERVICE_ID ?? '',
};

export const SENTRY = {
    DSN: import.meta.env.VITE_REACT_APP_SENTRY_DSN ?? '',
    ENABLED: import.meta.env.MODE != null && import.meta.env.MODE !== 'development',
    ENV: import.meta.env.MODE ?? 'development',
    RELEASE: import.meta.env.VITE_REACT_APP_SENTRY_VERSION,
    SAMPLE_RATE: import.meta.env.VITE_REACT_APP_SENTRY_SAMPLE_RATE ?? 1.0,
};

export const API_EXTERNAL = {
    CENSOR_CO_APPLICANT: {
        MAX_RETRIES: isNumber(Number(import.meta.env.VITE_REACT_APP_CENSOR_CO_APPLICANT_MAX_RETRIES))
            ? Number(import.meta.env.VITE_REACT_APP_CENSOR_CO_APPLICANT_MAX_RETRIES)
            : 60,
        RETRY_INTERVAL: isNumber(Number(import.meta.env.VITE_REACT_APP_CENSOR_CO_APPLICANT_RETRY_INTERVAL))
            ? Number(import.meta.env.VITE_REACT_APP_CENSOR_CO_APPLICANT_RETRY_INTERVAL)
            : 3000,
    },
    CENSOR_LOANREQUEST: {
        MAX_RETRIES: isNumber(Number(import.meta.env.VITE_REACT_APP_CENSOR_LOANREQUEST_MAX_RETRIES))
            ? Number(import.meta.env.VITE_REACT_APP_CENSOR_LOANREQUEST_MAX_RETRIES)
            : 60,
        RETRY_INTERVAL: isNumber(Number(import.meta.env.VITE_REACT_APP_CENSOR_LOANREQUEST_RETRY_INTERVAL))
            ? Number(import.meta.env.VITE_REACT_APP_CENSOR_LOANREQUEST_RETRY_INTERVAL)
            : 3000,
    },
    CONSORS: {
        ADD_NOTE: {
            MAX_RETRIES: isNumber(Number(import.meta.env.VITE_REACT_APP_CONSORS_API_ADD_NOTE_MAX_RETRIES))
                ? Number(import.meta.env.VITE_REACT_APP_CONSORS_API_ADD_NOTE_MAX_RETRIES)
                : 30,
            RETRY_INTERVAL: isNumber(Number(import.meta.env.VITE_REACT_APP_CONSORS_API_ADD_NOTE_RETRY_INTERVAL))
                ? Number(import.meta.env.VITE_REACT_APP_CONSORS_API_ADD_NOTE_RETRY_INTERVAL)
                : 1000,
        },
        CONSOLIDATION: {
            MAX_RETRIES: isNumber(Number(import.meta.env.VITE_REACT_APP_CONSORS_API_CONSOLIDATION_MAX_RETRIES))
                ? Number(import.meta.env.VITE_REACT_APP_CONSORS_API_CONSOLIDATION_MAX_RETRIES)
                : 30,
            RETRY_INTERVAL: isNumber(Number(import.meta.env.VITE_REACT_APP_CONSORS_API_CONSOLIDATION_RETRY_INTERVAL))
                ? Number(import.meta.env.VITE_REACT_APP_CONSORS_API_CONSOLIDATION_RETRY_INTERVAL)
                : 1000,
        },
        SUBSCRIPTION_CANCELLATION: {
            MAX_RETRIES: isNumber(
                Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_CANCELLATION_MAX_RETRIES),
            )
                ? Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_CANCELLATION_MAX_RETRIES)
                : 30,
            RETRY_INTERVAL: isNumber(
                Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_CANCELLATION_RETRY_INTERVAL),
            )
                ? Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_CANCELLATION_RETRY_INTERVAL)
                : 1000,
        },
        SUBSCRIPTION_REQUESTED: {
            MAX_RETRIES: isNumber(Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_REQUESTED_MAX_RETRIES))
                ? Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_REQUESTED_MAX_RETRIES)
                : 30,
            RETRY_INTERVAL: isNumber(
                Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_REQUESTED_RETRY_INTERVAL),
            )
                ? Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_REQUESTED_RETRY_INTERVAL)
                : 1000,
        },
        SUBSCRIPTION_VALIDATION: {
            MAX_RETRIES: isNumber(
                Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_VALIDATION_MAX_RETRIES),
            )
                ? Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_VALIDATION_MAX_RETRIES)
                : 30,
            RETRY_INTERVAL: isNumber(
                Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_VALIDATION_RETRY_INTERVAL),
            )
                ? Number(import.meta.env.VITE_REACT_APP_CONSORS_API_SUBSCRIPTION_VALIDATION_RETRY_INTERVAL)
                : 1000,
        },
    },
    EUROPACE: {
        ACCEPT_OFFER: {
            MAX_RETRIES: isNumber(Number(import.meta.env.VITE_REACT_APP_EUROPACE_ACCEPT_OFFER_MAX_RETRIES))
                ? Number(import.meta.env.VITE_REACT_APP_EUROPACE_ACCEPT_OFFER_MAX_RETRIES)
                : 15,
            RETRY_INTERVAL: isNumber(Number(import.meta.env.VITE_REACT_APP_EUROPACE_ACCEPT_OFFER_RETRY_INTERVAL))
                ? Number(import.meta.env.VITE_REACT_APP_EUROPACE_ACCEPT_OFFER_RETRY_INTERVAL)
                : 15_000,
        },
        REQUEST_OFFERS: {
            MAX_RETRIES: isNumber(Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_OFFERS_MAX_RETRIES))
                ? Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_OFFERS_MAX_RETRIES)
                : 60,
            RETRY_INTERVAL: isNumber(Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_OFFERS_RETRY_INTERVAL))
                ? Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_OFFERS_RETRY_INTERVAL)
                : 2_000,
        },
        REQUEST_PROCESS_EVENTS: {
            MAX_RETRIES: isNumber(Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_PROCESS_EVENTS_MAX_RETRIES))
                ? Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_PROCESS_EVENTS_MAX_RETRIES)
                : 60,
            RETRY_INTERVAL: isNumber(
                Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_PROCESS_EVENTS_RETRY_INTERVAL),
            )
                ? Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_PROCESS_EVENTS_RETRY_INTERVAL)
                : 1000,
        },
        REQUEST_PROCESS_TRANSMIT: {
            MAX_RETRIES: isNumber(Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_PROCESS_TRANSMIT_MAX_RETRIES))
                ? Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_PROCESS_TRANSMIT_MAX_RETRIES)
                : 15,
            RETRY_INTERVAL: isNumber(
                Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_PROCESS_TRANSMIT_RETRY_INTERVAL),
            )
                ? Number(import.meta.env.VITE_REACT_APP_EUROPACE_REQUEST_PROCESS_TRANSMIT_RETRY_INTERVAL)
                : 1000,
        },
        SYNCHRONIZATION_OFFERS: {
            MAX_RETRIES: isNumber(Number(import.meta.env.VITE_REACT_APP_EUROPACE_OFFERS_SYNCHRONIZATION_MAX_RETRIES))
                ? Number(import.meta.env.VITE_REACT_APP_EUROPACE_OFFERS_SYNCHRONIZATION_MAX_RETRIES)
                : 20,
            RETRY_INTERVAL: isNumber(
                Number(import.meta.env.VITE_REACT_APP_EUROPACE_OFFERS_SYNCHRONIZATION_RETRY_INTERVAL),
            )
                ? Number(import.meta.env.VITE_REACT_APP_EUROPACE_OFFERS_SYNCHRONIZATION_RETRY_INTERVAL)
                : 500,
        },
    },
};

export const DEVTOOLS = {
    ENABLED: import.meta.env.VITE_REACT_APP_DISABLE_DEVTOOLS !== 'true',
};

export const VITE_MODE = import.meta.env.MODE;

export const TRANSLATION_VERSION = import.meta.env.VITE_REACT_APP_TRANSLATION_VERSION ?? '0.0.1';
